import React from 'react';
import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useGetWiresFromOrganisation(org) {
  const searchQueryId = window.Livewire?.request?.searchQuery?.id;

  const common = page => ({ params: { page, search_query_id: searchQueryId } });
  const [state, q] = useAxios({
    url: `/api/v1/wires/organisation/${encodeURIComponent(org)}`,
    method: 'GET',
    ...common(1),
  }, { manual: true });
  const executeQuery = React.useCallback(page => q(common(page)), [q]);
  return [state, executeQuery];
}
